// extracted by mini-css-extract-plugin
export default {"app_loading":"loading_app_loading__UNDjs","app_loading_icon":"loading_app_loading_icon__K3nku","app_loading_tip":"loading_app_loading_tip__73OwY"};